import { Injectable } from '@angular/core';

import PeerConnectionAdminStatus from './jsons/PeerConnectionAdminStatus';

import ResourceGroupType from './jsons/ResourceGroupType';

import CustomersAdminState from './jsons/CustomersAdminState';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {
  PeerConnectionAdminStatus = PeerConnectionAdminStatus;
  ResourceGroupType = ResourceGroupType;
  CustomersAdminState = CustomersAdminState;
}
